import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { CategoryAcademyModel, DataCategoryAcademyModel }
from '../../models/academy/category-academy.model';

import { AcademyRepository }
from '../../repositories/academy.repository';

export class
InsertCategoryAcademyUseCase
implements UseCase<
DataCategoryAcademyModel,
CategoryAcademyModel
> {

    constructor(
        private repository:
        AcademyRepository
    ) {}

    execute(
        params: DataCategoryAcademyModel
    ):
    Observable<CategoryAcademyModel> {

        return this.repository
            .insertCategoryAcademy(
                params
            );
    }
}